import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- entities
import ProductOption from 'PMT/entities/menu/ProductOption';

import SortableList from 'PMT/components/SortableList';

export default class ProductOptionRow extends Component {

  static propTypes = {
    productOption: PropTypes.instanceOf(ProductOption).isRequired,

    onDelete: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.productOption.equals(this.props.productOption);
  }

  get productOption() {
    return this.props.productOption;
  }

  //
  // renderers
  //

  render() {
    return (
      <div className="product_edit_view__product_option_row row">

        {!this.props.readOnly &&
          <div className="product_edit_view__product_option_row__drag_handle">
            <SortableList.DragHandle />
          </div>
        }

        {!this.props.readOnly &&
          <i
            onClick={() => { this.props.onDelete(this.props.productOption); }}
            className="fa fa-trash pointer  product_edit_view__product_option_row__delete"
          />
        }
        
        <h4
          className="product_edit_view__product_option_row__name"
        >
          {this.productOption.name}
        </h4>

      </div>
    );
  }

}
